import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

import Theme from './Theme';

export default function TopNav() {
  return (
    <div className="d-flex flex-column">
      <Navbar className="bg-body-tertiary rounded-4 shadow-sm d-flex justify-content-between">
        <Container>
            <Theme />
          <Navbar.Collapse className="justify-content-end">
            <Navbar.Text>
              로그인됨: <a href="/dashboard">사용자1</a>
            </Navbar.Text>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}